/* eslint-disable no-undef */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
//project imports
import Card from 'src/common/refactoredComponents/card/Card';
import {
    ContentConatiner,
    ContentHeaderFooter,
    ContentBody,
    DemiText,
    RegularText,
    NormalDiv,
    OrderLeftColorCode,
    RegularTrucateText,
    StyledFlag,
    MycaseAndPrice,
    Prices,
} from './OrderCard.styled';
import { fromOrderTypeToModuleName } from 'src/utils/util';
import {
    orderStatusColorCode,
    getDefaultCTAId,
    fromOrderTypeToLabel,
    getReportUsageResourceType,
    getRoutePathWithParams,
    getOrderLockedAction,
    checkPriceOverRideOrderAmount,
    logErrorToConsole,
} from 'src/utils/util';
import {
    resetBomData,
    resetCreateOrUpdateSurgery,
    resetShipToAddress,
    resetSurgeryDetails,
    resetSurgeryDetailsReducer,
    reSetProgressBarStatus as resetProgressBarStatusSurgery,
    resetValidateAccountDetails,
} from 'src/pages/scheduleSurgery/redux/actions';
import { useTranslation } from 'react-i18next';
import { getDisplayDate } from 'src/utils/dateUtils';
import {
    setOrderSummaryModalState,
    setSendReportModalState,
    setOrderStatus,
    showDeleteOrderAction,
    setDynamicZIndex,
    setOrderSummaryTabAction,
    showHideRequestInvoice,
    showHideSearchModalAction,
    triggerEventNotification,
} from 'src/pages/orders/redux/actions';
import AlertCircle from 'src/assets/images/AlertCircle.svg';
import UnidItem from 'src/common/components/unidItem/UnidItem';
import { useHistory } from 'react-router';
import { getCTAWCMSLink } from 'src/constants/wcmsRedirectionLinks';
import { CTA_IDS, isCopyCtaId, isTrueCopyCtaId, ENABLED, ORDERS, VISIBLE } from 'src/constants/appConstants';
import { US_COUNTRY_CODE } from 'src/constants/appConstants';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import CreateTemplate from 'src/common/refactoredComponents/createTemplate';
import UnidHubOrderDeletePopup from '../../unidHubOrderDeletePopup/UnidHubOrderDeletePopup';
import {
    ConstantOrderTypeFilter,
    OrderStatuses,
    OrderSummaryTabs,
} from 'src/constants/orderListConstants.js';
import FlagRed from 'src/assets/images/FlagRed.svg';
import FlagYellow from 'src/assets/images/FlagYellow.svg';
import {
    resetDiscrepancyUsageDetails,
    resetProgressBarStatus,
    resetReportUsageStates,
    storeSurgeryDetails,
    getValidateAccountDetails,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import PriceTag from 'src/common/components/priceTags/priceTags';
import {
    checkIfOrderLockedFunc,
    getOrderStatusDetailsFunc,
} from 'src/pages/reportUsage/redux/saga/dataServices';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup';
import CreateEquityTemplate from 'src/pages/equity/components/common/createTemplate/index.jsx';
import { fetchUsageDetailsRequest } from 'src/pages/reportUsage/redux/action/actionCreators';
import MessageTemplate from 'src/pages/equity/components/common/notifications/MessageTemplate';
import { getConfigurations, resetNotes } from 'src/common/redux/actions';
import { setPediatricCheck } from 'src/common/redux/actions';
import { setActiveNavLink } from 'src/pages/home/redux/actions';
import UnsavedChanges from 'src/pages/scheduleSurgery/components/surgery/notifications/UnsavedChanges';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import NonTissueIconsmall from 'src/assets/images/NonTissueIconsmall.svg';
import TissueIconsmall from 'src/assets/images/TissueIconsmall.svg';
import ReplenishIcon from 'src/assets/images/ReplenishIcon.svg';
import { OrderTypeSpanContianer } from 'src/common/components/priceTags/priceTags.styled';
import { PINK_HIGHLIGHT_COLOR } from 'src/styles/fonts/MCFontConstants';
import {
    getEquityDetails,
    resetEquityDetails,
} from 'src/pages/equity/redux/actions';
import { GETEQUITYDETAILSDATA } from 'src/constants/productConstants';
import {
    resetConsignmentAddDetails,
} from 'src/pages/consignmentAdd/redux/actions';
import {Title} from 'src/pages/home/component/orders/ordersListView/OrdersListView.styled';
import {PARKED_LABEL} from 'src/styles/fonts/MCFontConstants';

const OrderCard = (props) => {
    const { t } = useTranslation();
    const history = useHistory();

    const {
        accountName,
        accountNumber,
        callToActionList: rawCallToActionList,
        hrefId,
        myCaseRef,
        orderStatusDescription,
        patientName,
        physicianDisplayName,
        procedureDescription,
        submitDate,
        surgeryDate,
        unidCaseId,
        unidPlanDetails,
        currentOrderType,
        orderStatusColor,
        isSearch,
        nonTissuePriceList,
        tissuePriceList,
        mbMarginBottom,
        createdBy,
        templateMandatoryFields,
        tissuePriceAndOverride,
        nonTissuePriceAndOverride,
        isUsSurgeryT,
        isUsSurgeryNT,
        isMtoStatus,
        secondaryVendorCaseId,
        secondaryVendorCaseNo,
        isUsageMastOrder,
        isMastOrder,
        setNotificationDetails,
        notificationDetails,
        sapOrderList,
        sapOrderNumber,
        isHistory,
        qrGenerated,
        torqueRecorded,
        qrGeneratedFromState
    } = props;
    const currentDate = getDisplayDate(new Date());
    const submitFormattedDate = getDisplayDate(new Date(submitDate));
    let diffTime =
        new Date(currentDate).getTime() -
        new Date(submitFormattedDate).getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const [retriggerEventNotification, setRetriggerEventNotification] =
        useState(false);
    const border = {
        border: '2px dashed #A8A8A8',
    };
    const vendorId = t('common.vendorLabel');
    const dispatch = useDispatch();
    const location = useLocation();

    const [deleteNotAllowedPopupOpen, setDeleteNotAllowedPopupOpen] =
        useState(false);
    const [, setRequestInvoice] = useState(false);
    const [showViewTemplate, handleViewTemplate] = useState(false);
    const [dialogZindex, setDialogZindex] = useState(10000);

    const initialOrderLockState = {
        show: false,
        myCaseRef: null,
        modifiedBy: null,
        action: null,
    };
    const [showOrderLockedPopup, setShowOrderLockedPopup] = useState(
        initialOrderLockState
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const { salesOrg } = useSelector((state) => ({
        salesOrg: state.loginReducer.salesOrg,
    }));
    const { orderSummaryModal } = useSelector(
        (state) => state.orderSummaryReducer
    );

    const hybrisUserDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );

    const { patientIdVisibility, patientInformationVisibility } = useSelector(
        (state) => state.loginReducer
    );
    const validateAccount = useSelector(
        (state) => state.surgeryvalidateAccountReducer.validateAccount
    );
    const [tempValidationData, setTempValidationData] = useState({});
    const [blockedAccountMessagePopUp, setBlockedAccountMessagePopUp] =
        useState(false);

    const onOpenSummaryHandler = (myCaseRef) => {
        // const equityAndConsignment = ['ZOR', 'ZKA', 'KE', 'KB'];
        // const equityAndConsignment = ['KB']; //ZOR, KE, ZKA removed
        // if (equityAndConsignment.includes(currentOrderType)) {
        //     window.location.href = ordersWCMSLinks(currentOrderType);
        //     const order = { myCaseRef: myCaseRef };
        //     const cta = { ctaId: CTA_IDS.viewOrder };
        //     window.location.href = getWCMSRedirectionLink(order, cta);
        // } else {
        // openOrderSummaryHandler(myCaseRef);
        dispatch(
            getConfigurations(
                {
                    resourceType: 'visibility',
                    module: fromOrderTypeToModuleName(
                        currentOrderType,
                        isMastOrder,
                        isUsageMastOrder
                    ),
                },
                ORDERS
            )
        );
        dispatch(setDynamicZIndex('2001'));
        dispatch(
            setOrderSummaryModalState({
                myCaseRef: myCaseRef,
                orderSummaryModal: !orderSummaryModal,
                isFromOrderHistory: isHistory,
            })
        );
        dispatch(
            setOrderStatus({
                orderStatus: orderStatusDescription,
            })
        );
        // }
    };

    const toggleViewTemplate = () => {
        handleViewTemplate(!showViewTemplate);
    };

    const getCopyCtaLabel = () => {
        const key = 'orders.orderListView.copyLabel';
        const label = t(key);
        return label && label !== key ? label : 'Copy';
    };

    const callToActionList = (Array.isArray(rawCallToActionList)
        ? isHistory &&
          currentOrderType === 'KB' &&
          !rawCallToActionList.some((cta) => isCopyCtaId(cta?.ctaId))
            ? [
                  {
                      ctaId: CTA_IDS.copyOrder,
                      ctaName: getCopyCtaLabel(),
                  },
                  ...rawCallToActionList,
              ]
            : rawCallToActionList
        : isHistory && currentOrderType === 'KB'
        ? [
              {
                  ctaId: CTA_IDS.copyOrder,
                  ctaName: getCopyCtaLabel(),
              },
          ]
        : []
    ).filter((cta) => {
        const isCopyCta = isCopyCtaId(cta?.ctaId);
        const isUS = countryISOCode === US_COUNTRY_CODE;
        return !(
            isHistory &&
            isCopyCta &&
            ((currentOrderType === 'ZOR' && !isUS) ||
                (currentOrderType === 'KB' && isUS))
        );
    });

    const getPrimaryCTA = () => {
        return callToActionList?.find((action) => {
            if (getDefaultCTAId(props) === action.ctaId) {
                return {
                    ...action,
                };
            }
        });
    };

    const getWCMSRedirectionLink = (order, cta) => {
        return getCTAWCMSLink(order, cta);
    };

    //Transfer Surgery
    const transferSurgery = (myCaseRef) => {
        dispatch(setActiveNavLink({ calendar: true, orders: false }));
        history.push({
            ...getRoutePathWithParams(`/transferSurgery/${myCaseRef}`),
            state: { from: location?.pathname ? location.pathname : null },
        });
    };

    const handleEventRetrigger = (data, flag = false) => {
        dispatch(
            triggerEventNotification(
                {
                    myCaseRef: data?.myCaseRef,
                    orderType: data?.orderType,
                },
                flag
            )
        );
    };

    useEffectWithErrorLogging(() => {
        // console.log("validateAccountOrder",validateAccount, tempValidationData);
        if (
            validateAccount.data &&
            validateAccount?.statusCode?.length > 0 &&
            !validateAccount.data.hasOwnProperty('blockMessage') &&
            tempValidationData.hasOwnProperty('primary') &&
            tempValidationData.hasOwnProperty('event')
        ) {
            // console.log("validateAccountOrder1",validateAccount, tempValidationData);
            handleCTAAction(
                tempValidationData.event,
                tempValidationData.primary
            );
            setTempValidationData({});
        }
    }, [validateAccount, tempValidationData]);

    useEffectWithErrorLogging(() => {
        if (
            validateAccount.data.blockMessage &&
            blockedAccountMessagePopUp === false
        ) {
            setBlockedAccountMessagePopUp(true);
        }
    }, [validateAccount, getValidateAccountDetails]);

    const handleCTAAction = async (event, cta) => {
        dispatch(setPediatricCheck(''));
        dispatch(resetNotes());
        event.stopPropagation();

        const isViewCTA =
            cta?.ctaId === CTA_IDS.viewOrder ||
            (typeof cta?.ctaName === 'string' &&
                cta.ctaName.trim().toLowerCase().includes('view'));

        if (isHistory && isViewCTA) {
            onOpenSummaryHandler(myCaseRef);
            return;
        }

        // Copy fires in order history for any copy CTA, and in the normal orders flow only
        // for the true copy CTAs (CTA_003/CTA3) so the Torque QR CTA (CTA_026) is preserved.
        const isCopyCTA =
            isCopyCtaId(cta?.ctaId) &&
            (isHistory || isTrueCopyCtaId(cta?.ctaId));
        if (isCopyCTA) {
            const isEquityOrder = currentOrderType === 'ZOR';
            const isConsignmentAddOrder = currentOrderType === 'KB';
            if (isEquityOrder) {
                dispatch(resetEquityDetails());
                // Reserve a brand new equity reference (creation call) so the
                // copied order is created as a distinct new order.
                dispatch(getEquityDetails(GETEQUITYDETAILSDATA));
                dispatch(
                    setActiveNavLink(
                        isHistory
                            ? { calendar: false, orders: false, inventory: false, more: true }
                            : { calendar: false, orders: true, inventory: false, more: false }
                    )
                );
                history.push({
                    ...getRoutePathWithParams(`/modifyEquity/${myCaseRef}`),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                        account: accountName,
                        sourceMyCaseRef: myCaseRef,
                        sourceOrderType: currentOrderType,
                        isFromOrderHistory: isHistory,
                        isCopyFromSummary: !isHistory,
                    },
                });
                return;
            }
            if (isConsignmentAddOrder) {
                dispatch(resetConsignmentAddDetails());
                    dispatch(
                    setActiveNavLink(
                        isHistory
                            ? { calendar: false, orders: false, inventory: false, more: true }
                            : { calendar: false, orders: true, inventory: false, more: false }
                    )
                );
                history.push({
                    ...getRoutePathWithParams(
                        '/consignmentAdd'
                    ),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                        account: accountName,
                        sourceMyCaseRef: myCaseRef,
                        sourceOrderType: currentOrderType,
                        isFromOrderHistory: isHistory,
                        isCopyFromSummary: !isHistory,
                    },
                });
                return;
            }

            // ZLC / ZLB "Copy" -> /scheduleSurgery
            if (!isEquityOrder && !isConsignmentAddOrder) {
                dispatch(resetSurgeryDetails());
                // A surgery order copied from the orders listing must keep the
                // "orders" nav link active (like equity/consignment); only fall
                // back to "calendar" when copied from a non-orders origin.
                const isFromOrdersPage = (location?.pathname || '').includes('/orders');
                dispatch(
                    setActiveNavLink(
                        isHistory
                            ? { calendar: false, orders: false, inventory: false, more: true }
                            : isFromOrdersPage
                            ? { calendar: false, orders: true, inventory: false, more: false }
                            : { calendar: true, orders: false, inventory: false, more: false }
                    )
                );
                history.push({
                    ...getRoutePathWithParams('/scheduleSurgery'),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                        sourceMyCaseRef: myCaseRef,
                        sourceOrderType: currentOrderType,
                        isMastOrder: isMastOrder,
                        isFromOrderHistory: isHistory,
                        isCopyFromSummary: !isHistory,
                        account: accountName,
                    },
                });
                return;
            }

            dispatch(
                setActiveNavLink({
                    calendar: !isEquityOrder && !isConsignmentAddOrder,
                    orders: isEquityOrder,
                    inventory: isConsignmentAddOrder,
                })
            );
            history.push({
                ...getRoutePathWithParams(
                    isEquityOrder
                        ? '/equity'
                        : isConsignmentAddOrder
                        ? '/consignmentAdd'
                        : '/scheduleSurgery'
                ),
                state: {
                    from: location?.pathname ? location.pathname : null,
                    sourceMyCaseRef: myCaseRef,
                    sourceOrderType: currentOrderType,
                    isFromOrderHistory: !!isHistory,
                },
            });
            return;
        }

        let orderLockedData, orderStatus;
        const orderLockAction = getOrderLockedAction(
            cta.ctaId,
            currentOrderType,
            orderStatusDescription
        );
        if (
            orderLockAction &&
            ((cta.ctaId === CTA_IDS.editOrder &&
                currentOrderType === 'ZLC' &&
                process.env.ENABLE_SCHEDULE_SURGERY) ||
                ((cta.ctaId === CTA_IDS.reportUsage ||
                    (currentOrderType === 'ZLB' &&
                        (cta.ctaId === CTA_IDS.editOrder ||
                            cta.ctaId === CTA_IDS.reportPayment))) &&
                    process.env.ENABLE_REPORT_USAGE))
        ) {
            orderLockedData = await checkIfOrderLockedFunc({
                action: orderLockAction,
                myCaseRefId: myCaseRef,
                orderType:
                    orderLockAction === 'ReportUsage'
                        ? 'ZLB'
                        : currentOrderType,
            });
            if (cta.ctaId === CTA_IDS.reportUsage) {
                orderStatus = await getOrderStatusDetailsFunc(myCaseRef);
            }
        }

        if (
            cta.ctaId === CTA_IDS.editOrder &&
            (currentOrderType === 'ZLC' || currentOrderType === 'ZOR') &&
            process.env.ENABLE_SCHEDULE_SURGERY
        ) {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : myCaseRef,
                    modifiedBy: orderLockedData?.user,
                    action: orderLockAction,
                });
            } else {
                dispatch(setActiveNavLink({ calendar: false, orders: true }));
                if (currentOrderType === 'ZOR') {
                    history.push({
                        ...getRoutePathWithParams(`/modifyEquity/${myCaseRef}`),
                        state: {
                            from: location?.pathname ? location.pathname : null,
                        },
                    });
                } else {
                    dispatch(setPediatricCheck(''));
                    dispatch(resetNotes());
                    dispatch(resetCreateOrUpdateSurgery());
                    dispatch(resetProgressBarStatusSurgery());
                    dispatch(resetSurgeryDetails());
                    dispatch(resetSurgeryDetailsReducer());
                    dispatch(resetShipToAddress());
                    dispatch(resetBomData());
                    history.push({
                        ...getRoutePathWithParams(
                            `/modifySurgery/${myCaseRef}`
                        ),
                        state: {
                            from: location?.pathname ? location.pathname : null,
                            navOrigin: 'orders',
                        },
                    });
                }
            }
        } else if (
            cta.ctaId === CTA_IDS.delete &&
            (currentOrderType === 'ZLC' ||
                currentOrderType === 'ZLB' ||
                currentOrderType === 'ZOR')
        ) {
            unidCaseId
                ? setDeleteNotAllowedPopupOpen(true)
                : dispatch(
                      showDeleteOrderAction({
                          isDeletePopup: true,
                          deleteMyCaseRef: myCaseRef,
                          isOrderDetailsModal: false,
                          isOtherUser:
                              hybrisUserDetails?.uid &&
                              hybrisUserDetails.uid !== createdBy
                                  ? true
                                  : false,
                      })
                  );
        } else if (
            cta.ctaId === CTA_IDS.viewOrder &&
            (currentOrderType === 'ZLC' ||
                currentOrderType === 'ZLB' ||
                currentOrderType === 'ZOR' ||
                currentOrderType === 'KE' ||
                currentOrderType === 'ZKA' ||
                currentOrderType === 'KB')
        ) {
            onOpenSummaryHandler(myCaseRef);
        } else if (
            cta.ctaId === CTA_IDS.viewAdjustments &&
            currentOrderType === 'ZKA'
        ) {
            onOpenSummaryHandler(myCaseRef);
        } else if (
            cta.ctaId === CTA_IDS.billingSummary &&
            (currentOrderType === 'ZLC' ||
                currentOrderType === 'ZLB' ||
                currentOrderType === 'ZOR')
        ) {
            dispatch(
                setOrderSummaryTabAction({
                    selectedTabId: OrderSummaryTabs()[4].id,
                }) //Setting Billing Summary Id to OrderSummary redux state selectedTabId.
            );
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: myCaseRef,
                    //resourceType: 'BILLING_SUMMARY',
                    orderSummaryModal: !orderSummaryModal,
                          isFromOrderHistory: isHistory,
                })
            );
        } else if (cta.ctaId === CTA_IDS.retriggerNotification) {
            setRetriggerEventNotification &&
                setRetriggerEventNotification(true);
            setNotificationDetails &&
                setNotificationDetails({
                    orderType: currentOrderType,
                    myCaseRef: myCaseRef,
                });
        } else if (
            cta.ctaId === CTA_IDS.viewUsageReports &&
            (currentOrderType === 'ZLC' || currentOrderType === 'ZLB')
        ) {
            dispatch(resetDiscrepancyUsageDetails());
            const sendReportModalObject = {
                showModal: true,
                myCaseRefId: myCaseRef,
            };
            !isSearch
                ? (sendReportModalObject['isUsageReportOrderListPage'] = true)
                : (sendReportModalObject['isUsageReportSearchListPage'] = true);
            dispatch(setSendReportModalState(sendReportModalObject));
            if (
                orderStatusDescription ===
                    OrderStatuses().paymentInformationNeeded ||
                orderStatusDescription === OrderStatuses().billingIssues
            ) {
                dispatch(
                    fetchUsageDetailsRequest({
                        resourceType: 'reportPayment',
                        myCaseRef: myCaseRef,
                        isDiscrepencyCheck: true,
                    })
                );
            }
            if (isSearch) {
                dispatch(
                    showHideSearchModalAction({
                        showSearchModal: false,
                    })
                );
            }
        } else if (
            cta.ctaId === CTA_IDS.requestInvoice &&
            (currentOrderType === 'ZLC' ||
                currentOrderType === 'ZLB' ||
                currentOrderType === 'ZOR' ||
                currentOrderType === 'KE' ||
                currentOrderType === 'KB')
        ) {
            setRequestInvoice((prev) => !prev);
            const requestInvoiceProp = {
                requestInvoiceState: true,
                myCaseRefId: myCaseRef,
            };
            !isSearch
                ? (requestInvoiceProp['isRequestInvoiceOrderListPage'] = true)
                : (requestInvoiceProp['isRequestInvoiceSearchListPage'] = true);
            dispatch(showHideRequestInvoice(requestInvoiceProp));
            if (isSearch) {
                dispatch(
                    showHideSearchModalAction({
                        showSearchModal: false,
                    })
                );
            }
        } else if (
            cta.ctaId === CTA_IDS.createTemplate &&
            (currentOrderType === 'ZLC' ||
                currentOrderType === 'ZLB' ||
                currentOrderType === 'ZOR')
        ) {
            toggleViewTemplate();
        } else if (
            (cta.ctaId === CTA_IDS.reportUsage ||
                (currentOrderType === 'ZLB' &&
                    (cta.ctaId === CTA_IDS.editOrder ||
                        cta.ctaId === CTA_IDS.reportPayment))) &&
            process.env.ENABLE_REPORT_USAGE
        ) {
            if (
                orderLockedData?.isOrderLocked ||
                (orderStatus?.statusDescription === 'Records Found' &&
                    !orderStatus?.status?.includes('Exception') &&
                    (orderStatus.status.includes(
                        'Usage Order Submitted Successfully'
                    ) ||
                        orderStatus.status.toLowerCase().includes('process')))
            ) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : myCaseRef,
                    modifiedBy: orderLockedData?.user
                        ? orderLockedData?.user
                        : orderStatus?.userId,
                    action: orderLockAction,
                });
            } else {
                dispatch(resetProgressBarStatus());
                dispatch(resetReportUsageStates());
                const reportUsageObj = {
                    resourceType: getReportUsageResourceType(
                        orderStatusDescription,
                        cta.ctaId
                    ),
                    myCaseRef: myCaseRef,
                    fromOrdersList: true,
                    isFromOrderDetailsModal: false,
                };
                dispatch(storeSurgeryDetails(reportUsageObj));
                localStorage.setItem(
                    'myCaseRefUsage',
                    JSON.stringify(reportUsageObj)
                );
                history.push({
                    ...getRoutePathWithParams(`/reportUsage/${myCaseRef}`),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                    },
                });
            }
        } else if (
            cta.ctaId === CTA_IDS.transfer &&
            (currentOrderType === 'ZLC' || currentOrderType === 'ZLB') &&
            process.env.ENABLE_SCHEDULE_SURGERY
        ) {
            transferSurgery(myCaseRef);
        } else if (
            cta.ctaId === CTA_IDS.shippingTracking &&
            (currentOrderType === 'ZOR' || currentOrderType === 'KB')
        ) {
            dispatch(
                setOrderSummaryTabAction({
                    selectedTabId: OrderSummaryTabs()[3].id,
                })
            );
            // if (isSearchOrderList) {
            //     dispatch(
            //         showHideSearchModalAction({
            //             showSearchModal: false,
            //         })
            //     );
            // }
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: myCaseRef,
                    orderSummaryModal: !orderSummaryModal,
                          isFromOrderHistory: isHistory,
                })
            );
        } else {
            window.location.href = getWCMSRedirectionLink(props, cta);
        }
    };

    const orderTypeLabel = (orderType, sapOrderIsMast = false) => {
        if (orderType === 'ZLCR') {
            return t('orders.orderTypes.replenishment');
        }
        if (orderType === 'ZLC') {
            return fromOrderTypeToLabel(orderType, sapOrderIsMast);
        }
        const match = (ConstantOrderTypeFilter() || []).find(
            (entry) =>
                Array.isArray(entry?.orderType) &&
                entry.orderType.includes(orderType)
        );
        return match?.orderTypeName || orderType || '';
    };

    const fallbackSapOrderList = [
        {
            isNonTissue: true,
            isTissue: false,
            orderType: 'ZLC',
            sapOrderNo: '61668313644',
        },
        {
            isNonTissue: false,
            isTissue: true,
            orderType: 'ZLB',
            sapOrderNo: 'HSA00770004',
        },
        {
            isNonTissue: false,
            isTissue: true,
            orderType: 'ZOR',
            sapOrderNo: 'HSA00474724',
        },
        {
            isNonTissue: false,
            isTissue: true,
            orderType: 'ZOR',
            sapOrderNo: 'HSA00474724',
        },
    ];

    const sapOrders = Array.isArray(sapOrderList)
        ? sapOrderList
        : sapOrderNumber
        ? [
              {
                  sapOrderNo: sapOrderNumber,
                  orderType: currentOrderType,
              },
          ]
        : fallbackSapOrderList;

    const getSapOrderIconMeta = (order) => {
        const hasExplicitFlags =
            typeof order?.isTissue === 'boolean' ||
            typeof order?.isNonTissue === 'boolean';

        const isReplenishment = order?.orderType === 'ZLCR';
        const isNonTissue = hasExplicitFlags
            ? !!order?.isNonTissue
            : order?.orderType === 'ZLC';
        const isTissue = hasExplicitFlags
            ? !!order?.isTissue
            : !!order?.orderType &&
              !isNonTissue &&
              order?.orderType !== 'ZOR' &&
              !isReplenishment;
        const isReturn = order?.orderType === 'ZOR';

        return {
            showIcon: isTissue || isNonTissue,
            isTissue,
            isNonTissue,
            isReturn,
            isReplenishment,
        };
    };

    return (
        <>
            <Card
                id={`orders-ordercard-${myCaseRef}-card`}
                border={
                    orderStatusDescription ===
                        t('orders.orderStatuses.draftNotSubmitted') && border
                }
                onClick={() => onOpenSummaryHandler(myCaseRef)}
                mobileMargin={'1% 4%'}
                mobileMaxWidth={'100%'}
                mbMarginBottom={mbMarginBottom}
            >
                {orderStatusColor === 'status-error' && (
                    <StyledFlag>
                        <img
                            src={FlagRed}
                            alt="icon"
                            height={'24px'}
                            width={'24px'}
                        />
                    </StyledFlag>
                )}
                {orderStatusColor === 'status-warning' && (
                    <StyledFlag>
                        <img
                            src={FlagYellow}
                            alt="icon"
                            height={'24px'}
                            width={'24px'}
                        />
                    </StyledFlag>
                )}
                <OrderLeftColorCode
                    backgroundColor={orderStatusColorCode(
                        orderStatusDescription
                    )}
                    borderColor={orderStatusColorCode(orderStatusDescription)}
                />
                <ContentConatiner diplay={'block'}>
                    <ContentHeaderFooter isContentHeaderFooter={true}>
                        <NormalDiv isContentHeaderFooter={true}>
                            <RegularText color="#C529BB" margin="0 6px 0 2px">
                                {fromOrderTypeToLabel(
                                    currentOrderType,
                                    props.isMastOrder
                                )}
                            </RegularText>
                            <RegularText
                                color="#585858"
                                margin="0 4px 0 0"
                                lineHeight={'18px'}
                            >
                                {orderStatusDescription ===
                                OrderStatuses().draftNotSubmitted //Draft not submitted
                                    ? t('orders.orderStatuses.saved')
                                    : t(
                                          'orders.priceOverrideHistoryStatus.submitted'
                                      )}
                            </RegularText>
                            <DemiText
                                color="#585858"
                                margin="0 0 0 2px"
                                lineHeight={'18px'}
                            >
                                {getDisplayDate(new Date(submitDate))}
                            </DemiText>
                        </NormalDiv>
                        <NormalDiv isContentHeaderFooter={true}>
                            {surgeryDate && (
                                <>
                                    <RegularText margin="0 2.5px 0 0">
                                        {t(
                                            'orders.priceOverrideHistoryStatus.surgerydate'
                                        )}
                                    </RegularText>
                                    <DemiText
                                        color="#585858"
                                        margin="0 0 0 2px"
                                        lineHeight={'18px'}
                                    >
                                        {getDisplayDate(
                                            new Date(
                                                surgeryDate.includes('2050')
                                                    ? surgeryDate.replace(
                                                          'Z',
                                                          ''
                                                      )
                                                    : surgeryDate
                                            )
                                        )}
                                    </DemiText>{' '}
                                </>
                            )}
                        </NormalDiv>
                    </ContentHeaderFooter>
                    <ContentBody margin="15px 0 6px 0">
                        {isHistory&&<DemiText
                            fontSize="14px"
                            color="#1010EB"
                            lineHeight={'24px'}
                        >
                            {myCaseRef}
                        </DemiText>}
                        {isHistory ? (
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: '55% 40%',
                                    columnGap: '12px',
                                    width: '100%',
                                    alignItems: 'flex-start',
                                    margin: '10px 0px 10px 0px',
                                }}
                            >
                                <div
                                    style={{
                                        minWidth: 0,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '6px',
                                        overflowWrap: 'anywhere',
                                    }}
                                >
                                    {hrefId && (
                                        <NormalDiv margin="0">
                                            <DemiText
                                                color="#585858"
                                                fontSize="12px"
                                                margin="0 2px 0 0"
                                                lineHeight={'21px'}
                                            >
                                                {t('common.hrefLabel')}{' '}
                                            </DemiText>{' '}
                                            <RegularText
                                                color="#1010EB"
                                                fontSize="12px"
                                                lineHeight={'21px'}
                                            >
                                                {hrefId}
                                            </RegularText>
                                        </NormalDiv>
                                    )}
                                    {physicianDisplayName && (
                                        <DemiText
                                            color="#140F4B"
                                            fontSize="14px"
                                            lineHeight={'24px'}
                                        >
                                            {t('common.drLabel') +
                                                ' ' +
                                                physicianDisplayName}
                                        </DemiText>
                                    )}
                                    <NormalDiv display={'flow'}>
                                        <RegularTrucateText
                                            fontSize="14px"
                                            color="#140F4B"
                                            width="auto"
                                            lineHeight={'24px'}
                                        >
                                            {accountName}
                                        </RegularTrucateText>
                                        <RegularText
                                            fontFamily="AvenirNextWorld Italic"
                                            fontSize="14px"
                                            lineHeight={'24px'}
                                        >
                                            {parseInt(accountNumber, 10)}
                                        </RegularText>
                                    </NormalDiv>
                                    <RegularText
                                        color="#140F4B"
                                        fontSize="12px"
                                        margin="0"
                                        lineHeight={'21px'}
                                    >
                                        {procedureDescription}
                                    </RegularText>
                                    {unidCaseId && (
                                        <UnidItem
                                            uniDId={unidCaseId}
                                            planStatus={unidPlanDetails}
                                            showPlan={isMtoStatus}
                                            isMobileView={true}
                                            isShowStatus
                                            fromOrderPage
                                        />
                                    )}
                                    {secondaryVendorCaseNo && (
                                        <NormalDiv>
                                            <RegularText
                                                color="#4F4F4F"
                                                fontSize="12px"
                                                margin="0 2px 0 0"
                                            >
                                                {vendorId}
                                            </RegularText>

                                            <RegularText
                                                color="#140F4B"
                                                fontSize="12px"
                                            >
                                                {secondaryVendorCaseNo}
                                            </RegularText>
                                        </NormalDiv>
                                    )}
                                    <NormalDiv>
                                        {patientName && (
                                            <>
                                                <RegularText
                                                    color="#4F4F4F"
                                                    fontSize="12px"
                                                    margin="0 2px 0 0"
                                                >
                                                    {t(
                                                        'consignmentBilling.common.consignmentBillingHeader.patient'
                                                    )}
                                                </RegularText>

                                                <RegularText
                                                    color="#140F4B"
                                                    fontSize="12px"
                                                >
                                                    {patientName}
                                                </RegularText>
                                            </>
                                        )}
                                    </NormalDiv>
                                </div>

                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-end',
                                        justifySelf: 'end',
                                        minWidth: 0,
                                    }}
                                >
                                    <div style={{ marginRight: '-114px' }}>
                                    <Prices
                                        marginFlag={
                                            !(
                                                nonTissuePriceList ||
                                                tissuePriceList
                                            )
                                                ? '0px -11px'
                                                : null
                                        }
                                    >
                                        {(nonTissuePriceList ||
                                            isUsSurgeryNT) && (
                                            <PriceTag
                                                isUSUser={false}
                                                width={'fit-content'}
                                                mobileMarginTop={'0%'}
                                                priceArray={nonTissuePriceList}
                                                nonTissue={true}
                                                isInvoiceStatus
                                                invoiceDataMargin={
                                                    nonTissuePriceList &&
                                                    tissuePriceList &&
                                                    '0 0.5rem 0 0'
                                                }
                                                isUsSurgeryT={isUsSurgeryT}
                                                isUsSurgeryNT={isUsSurgeryNT}
                                                isPriceOverride={
                                                    nonTissuePriceAndOverride?.length >
                                                    0
                                                        ? checkPriceOverRideOrderAmount(
                                                              nonTissuePriceAndOverride
                                                          )
                                                        : false
                                                }
                                            />
                                        )}
                                        {(tissuePriceList || isUsSurgeryT) && (
                                            <PriceTag
                                                isUSUser={false}
                                                width={'fit-content'}
                                                mobileMarginTop={'0%'}
                                                priceArray={tissuePriceList}
                                                nonTissue={false}
                                                isUsSurgeryT={isUsSurgeryT}
                                                isUsSurgeryNT={isUsSurgeryNT}
                                                isInvoiceStatus
                                                isPriceOverride={
                                                    tissuePriceAndOverride?.length >
                                                    0
                                                        ? checkPriceOverRideOrderAmount(
                                                              tissuePriceAndOverride
                                                          )
                                                        : false
                                                }
                                            />
                                        )}
                                    </Prices>
                                    </div>

                                    <div
                                        style={{
                                            marginTop: '6px',
                                            width: '100%',
                                            maxWidth: '220px',
                                            boxSizing: 'border-box',
                                        }}
                                    >
                                        {sapOrders?.length > 0 ? (
                                            sapOrders.map((order, idx) => (
                                                <div
                                                    key={`${
                                                        order?.sapOrderNo ||
                                                        'sap'
                                                    }-${
                                                        order?.orderType ||
                                                        'type'
                                                    }-${idx}`}
                                                    style={{
                                                        marginBottom:
                                                            idx ===
                                                            sapOrders.length - 1
                                                                ? '0px'
                                                                : '8px',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'grid',
                                                            gridTemplateColumns:
                                                                '24px minmax(0, 1fr)',
                                                            columnGap: '6px',
                                                            rowGap: '2px',
                                                            alignItems:
                                                                'center',
                                                        }}
                                                    >
                                                        {getSapOrderIconMeta(
                                                            order
                                                        )?.isReplenishment ? (
                                                            <OrderTypeSpanContianer
                                                                sourcePath={
                                                                    ReplenishIcon
                                                                }
                                                                ipadSourcePath={
                                                                    ReplenishIcon
                                                                }
                                                                marginLeft={
                                                                    '0px'
                                                                }
                                                                marginRight={
                                                                    '0px'
                                                                }
                                                            />
                                                        ) : getSapOrderIconMeta(
                                                            order
                                                        )?.showIcon ? (
                                                            <OrderTypeSpanContianer
                                                                sourcePath={
                                                                    getSapOrderIconMeta(
                                                                        order
                                                                    )?.isTissue
                                                                        ? TissueIconsmall
                                                                        : NonTissueIconsmall
                                                                }
                                                                ipadSourcePath={
                                                                    getSapOrderIconMeta(
                                                                        order
                                                                    )?.isTissue
                                                                        ? TissueIconsmall
                                                                        : NonTissueIconsmall
                                                                }
                                                                marginLeft={
                                                                    '0px'
                                                                }
                                                                marginRight={
                                                                    '0px'
                                                                }
                                                            />
                                                        ) : getSapOrderIconMeta(
                                                              order
                                                          )?.isReturn ? (
                                                            <div
                                                                style={{
                                                                    width: '24px',
                                                                    height: '18px',
                                                                    display:
                                                                        'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    justifyContent:
                                                                        'center',
                                                                    fontFamily:
                                                                        'AvenirNextWorld Demi',
                                                                    fontSize:
                                                                        '10px',
                                                                    color: PINK_HIGHLIGHT_COLOR,
                                                                }}
                                                            >
                                                                R
                                                            </div>
                                                        ) : (
                                                            <div
                                                                style={{
                                                                    width: '24px',
                                                                    height: '18px',
                                                                }}
                                                            />
                                                        )}

                                                        <RegularTrucateText
                                                            fontSize={'12px'}
                                                            width={'auto'}
                                                            title={
                                                                order?.sapOrderNo ||
                                                                ''
                                                            }
                                                            style={{
                                                                lineHeight:
                                                                    '16px',
                                                                margin: 0,
                                                                whiteSpace:
                                                                    'nowrap',
                                                                overflow:
                                                                    'hidden',
                                                                textOverflow:
                                                                    'ellipsis',
                                                                maxWidth:
                                                                    '100%',
                                                            }}
                                                        >
                                                            {order?.sapOrderNo ||
                                                                ''}
                                                        </RegularTrucateText>

                                                        <div />
                                                        <RegularTrucateText
                                                            fontSize={'12px'}
                                                            width={'auto'}
                                                            color={
                                                                PINK_HIGHLIGHT_COLOR
                                                            }
                                                            title={orderTypeLabel(
                                                                order?.orderType,
                                                                order?.isMastOrder ?? isMastOrder
                                                            )}
                                                            style={{
                                                                lineHeight:
                                                                    '16px',
                                                                margin: 0,
                                                                whiteSpace:
                                                                    'nowrap',
                                                                overflow:
                                                                    'hidden',
                                                                textOverflow:
                                                                    'ellipsis',
                                                                maxWidth:
                                                                    '100%',
                                                            }}
                                                        >
                                                            {orderTypeLabel(
                                                                order?.orderType,
                                                                order?.isMastOrder ?? isMastOrder
                                                            )}
                                                        </RegularTrucateText>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div style={{ height: '21px' }} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                <MycaseAndPrice>
                                    <DemiText
                            fontSize="14px"
                            color="#1010EB"
                            lineHeight={'24px'}
                        >
                            {myCaseRef}
                        </DemiText>
                                    <Prices
                                        marginFlag={
                                            !(
                                                nonTissuePriceList ||
                                                tissuePriceList
                                            )
                                                ? '0px -11px'
                                                : null
                                        }
                                    >
                                        {(nonTissuePriceList ||
                                            isUsSurgeryNT) && (
                                            <PriceTag
                                                isUSUser={
                                                    countryISOCode == 'US'
                                                }
                                                width={'fit-content'}
                                                mobileMarginTop={'0%'}
                                                priceArray={nonTissuePriceList}
                                                nonTissue={true}
                                                isInvoiceStatus
                                                invoiceDataMargin={
                                                    nonTissuePriceList &&
                                                    tissuePriceList &&
                                                    '0 0.5rem 0 0'
                                                }
                                                isUsSurgeryT={isUsSurgeryT}
                                                isUsSurgeryNT={isUsSurgeryNT}
                                                isPriceOverride={
                                                    nonTissuePriceAndOverride?.length >
                                                    0
                                                        ? checkPriceOverRideOrderAmount(
                                                              nonTissuePriceAndOverride
                                                          )
                                                        : false
                                                }
                                            />
                                        )}
                                        {(tissuePriceList || isUsSurgeryT) && (
                                            <PriceTag
                                                isUSUser={
                                                    countryISOCode == 'US'
                                                }
                                                width={'fit-content'}
                                                mobileMarginTop={'0%'}
                                                priceArray={tissuePriceList}
                                                nonTissue={false}
                                                isUsSurgeryT={isUsSurgeryT}
                                                isUsSurgeryNT={isUsSurgeryNT}
                                                isInvoiceStatus
                                                isPriceOverride={
                                                    tissuePriceAndOverride?.length >
                                                    0
                                                        ? checkPriceOverRideOrderAmount(
                                                              tissuePriceAndOverride
                                                          )
                                                        : false
                                                }
                                            />
                                        )}
                                    </Prices>
                                </MycaseAndPrice>

                                {hrefId ? (
                                    <NormalDiv margin="15px 0 7px 0px">
                                        <DemiText
                                            color="#585858"
                                            fontSize="12px"
                                            margin="0 2px 0 0"
                                            lineHeight={'21px'}
                                        >
                                            {t('common.hrefLabel')}{' '}
                                        </DemiText>{' '}
                                        <RegularText
                                            color="#1010EB"
                                            fontSize="12px"
                                            lineHeight={'21px'}
                                        >
                                            {hrefId}
                                        </RegularText>
                                    </NormalDiv>
                                ) : (
                                    <NormalDiv height="22px"></NormalDiv>
                                )}
                                {physicianDisplayName && (
                                    <DemiText
                                        color="#140F4B"
                                        fontSize="14px"
                                        lineHeight={'24px'}
                                    >
                                        {t('common.drLabel') +
                                            ' ' +
                                            physicianDisplayName}
                                    </DemiText>
                                )}
                                <NormalDiv>
                                    <RegularTrucateText
                                        fontSize="14px"
                                        color="#140F4B"
                                        width="auto"
                                        lineHeight={'24px'}
                                    >
                                        {accountName}
                                    </RegularTrucateText>
                                    <RegularText
                                        fontFamily="AvenirNextWorld Italic"
                                        fontSize="14px"
                                        margin="0 0 0 7px"
                                        lineHeight={'24px'}
                                    >
                                        {parseInt(accountNumber, 10)}
                                    </RegularText>
                                </NormalDiv>
                                <RegularText
                                    color="#140F4B"
                                    fontSize="12px"
                                    margin="0 0 15px 0px"
                                    lineHeight={'21px'}
                                >
                                    {procedureDescription}
                                </RegularText>
                                {unidCaseId ? (
                                    <UnidItem
                                        uniDId={unidCaseId}
                                        planStatus={unidPlanDetails}
                                        showPlan={isMtoStatus}
                                        isMobileView={true}
                                        isShowStatus
                                        fromOrderPage
                                    />
                                ) : (
                                    <NormalDiv height="22px"></NormalDiv>
                                )}
                                {secondaryVendorCaseNo ? (
                                    <NormalDiv>
                                        <RegularText
                                            color="#4F4F4F"
                                            fontSize="12px"
                                            margin="0 2px 0 0"
                                        >
                                            {vendorId}
                                        </RegularText>

                                        <RegularText
                                            color="#140F4B"
                                            fontSize="12px"
                                        >
                                            {secondaryVendorCaseNo}
                                        </RegularText>
                                    </NormalDiv>
                                ) : null}
                                <NormalDiv>
                                    {patientName ? (
                                        <>
                                            <RegularText
                                                color="#4F4F4F"
                                                fontSize="12px"
                                                margin="0 2px 0 0"
                                            >
                                                {t(
                                                    'consignmentBilling.common.consignmentBillingHeader.patient'
                                                )}
                                            </RegularText>

                                            <RegularText
                                                color="#140F4B"
                                                fontSize="12px"
                                            >
                                                {patientName}
                                            </RegularText>
                                        </>
                                    ) : (
                                        <NormalDiv height="22px"></NormalDiv>
                                    )}
                                </NormalDiv>
                            </>
                        )}
                    </ContentBody>
                    <ContentHeaderFooter width={'100%'}>
                        <RegularTrucateText
                            color={
                                (orderStatusDescription ===
                                    t(
                                        'orders.orderQuickFilters.usageOrders.awaitingPO.statusNotes.paymentInformationNeeded'
                                    ) ||
                                    orderStatusDescription ===
                                        t('calendar.actionPanel.awaitingPO')) &&
                                diffDays > 30
                                    ? '#EB475B'
                                    : '#3C3C3C'
                            }
                            fontSize="14px"
                            fontFamily="AvenirNextWorld Demi"
                            width="55%"
                            display={'flex'}
                            alignItems={'center'}
                        >
                            {(orderStatusDescription ===
                                t(
                                    'orders.orderQuickFilters.usageOrders.awaitingPO.statusNotes.paymentInformationNeeded'
                                ) ||
                                orderStatusDescription ===
                                    t('calendar.actionPanel.awaitingPO')) &&
                            diffDays > 30 ? (
                                <img
                                    src={AlertCircle}
                                    alt="alertCircle"
                                    height={'24px'}
                                    width={'24px'}
                                />
                            ) : null}
                            {orderStatusDescription}
                        </RegularTrucateText>

                        <DemiText
                            id={`orders-ordercard-${myCaseRef}-primary-cta-button`}
                            flexShrink="0"
                            color="#1010EB"
                            fontSize="14px"
                            border={
                                getPrimaryCTA()?.ctaName && '1px solid #1010EB'
                            }
                            borderRadius={getPrimaryCTA()?.ctaName && '25px'}
                            padding={getPrimaryCTA()?.ctaName && '5px 12px'}
                            onClick={(event) => {
                                event.stopPropagation();
                                if (
                                    getPrimaryCTA()?.ctaName === 'Report Usage'
                                ) {
                                    const SURGERYVALIDATEACCOUNT = {
                                        orderType: 'ZLC',
                                        sapPartnerId: accountNumber
                                            .toString()
                                            .padStart(10, '0'),
                                    };
                                    dispatch(
                                        getValidateAccountDetails(
                                            SURGERYVALIDATEACCOUNT
                                        )
                                    );
                                    if (!validateAccount?.data?.blockMessage) {
                                        setTempValidationData({
                                            event: event,
                                            primary: getPrimaryCTA(),
                                        });
                                    }
                                } else {
                                    handleCTAAction(event, getPrimaryCTA());
                                }
                            }}
                        >
                            {getPrimaryCTA()?.ctaName
                                ? getPrimaryCTA().ctaName
                                : null}
                        </DemiText>
                       { torqueRecorded ? <Title color={PARKED_LABEL}>{t('orders.recordTorque.torqueRecorded')}</Title> :  qrGenerated ? <Title>{t('orders.recordTorque.qrGenerated')}</Title> : (qrGeneratedFromState?.[myCaseRef] ? <Title>{t('orders.recordTorque.qrGenerated')}</Title> : null)}
                    </ContentHeaderFooter>
                </ContentConatiner>
            </Card>
            {deleteNotAllowedPopupOpen && (
                <UnidHubOrderDeletePopup
                    id={`orders-ordercard-${myCaseRef}-unidhub-delete-popup`}
                    margin
                    buttonMargin={'21px 0px'}
                    onClose={() => {
                        try {
                            setDeleteNotAllowedPopupOpen((prev) => !prev);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
            )}
            {showOrderLockedPopup.show && (
                <CancelAlertPopup
                    popupTitle={t('orders.shipTrackLabels.lockededit')}
                    alertMessage={`${t('orders.shipTrackLabels.mycaseorder')} ${
                        showOrderLockedPopup.myCaseRef
                    } ${t('orders.shipTrackLabels.msg')} ${
                        showOrderLockedPopup.modifiedBy
                    }.`}
                    btn1Label={t(
                        'orders.orderDetails.orderDetailFooter.cancel'
                    )}
                    cancelBtn
                    btn2Label={
                        showOrderLockedPopup?.action !== 'DraftUsageEdit' &&
                        t('accounts.accountFilterBox.view')
                    }
                    btnCloseClickHandler={() =>
                        setShowOrderLockedPopup(initialOrderLockState)
                    }
                    btn1ClickHandler={() =>
                        setShowOrderLockedPopup(initialOrderLockState)
                    }
                    btn2ClickHandler={() => {
                        try {
                            onOpenSummaryHandler(
                                showOrderLockedPopup.myCaseRef
                            );
                            setShowOrderLockedPopup(initialOrderLockState);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
            )}
            {blockedAccountMessagePopUp &&
            validateAccount?.data?.blockMessage ? (
                <MessageTemplate
                    id={`orders-ordercard-${myCaseRef}-blocked-account-message`}
                    isDeliveryCheck={true}
                    onClose={() => {
                        try {
                            dispatch(resetValidateAccountDetails());
                            setBlockedAccountMessagePopUp(false);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    content={validateAccount?.data?.blockMessage}
                    width={'100%'}
                    marginB={'32px'}
                    position={'static'}
                    height={'auto'}
                    title={t(
                        'ConsignmentAdd.surgery.notifications.accountBlocked'
                    )}
                    fontWeight={'800'}
                    blocked
                    background={'None'}
                />
            ) : null}
            {showViewTemplate && (
                <>
                    <ModalDialog
                        marginTop={'16.2rem'}
                        overflowX={'hidden'}
                        maxWidth={'841px'}
                        handleClose={toggleViewTemplate}
                        zIndex={dialogZindex}
                        paddingBottom={'190px'}
                        padding={'16px 3px 16px 16px'}
                        isMobileDevice={true}
                        afterSubmitTemplate={false}
                    >
                        {currentOrderType === 'ZOR' ? (
                            <CreateEquityTemplate
                                id={`orders-ordercard-${myCaseRef}-create-equity-template`}
                                handleClose={toggleViewTemplate}
                                orderData={props?.myCaseRef}
                                origin={'orders'}
                                onOpen={() => {
                                    try {
                                        setDialogZindex(2000);
                                        //onSelectOpen();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                onClose={() => {
                                    try {
                                        setDialogZindex(10000);
                                        //onSelectClose();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                            />
                        ) : (
                            <CreateTemplate
                                id={`orders-ordercard-${myCaseRef}-create-template`}
                                handleClose={toggleViewTemplate}
                                orderData={props?.myCaseRef}
                                origin={'orders'}
                                onOpen={() => {
                                    try {
                                        setDialogZindex(2000);
                                        //onSelectOpen();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                onClose={() => {
                                    try {
                                        setDialogZindex(10000);
                                        //onSelectClose();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                templateMandatoryFields={
                                    templateMandatoryFields
                                }
                            />
                        )}
                    </ModalDialog>
                </>
            )}
            {retriggerEventNotification && (
                <UnsavedChanges
                    isFromSummary={true}
                    isFromOrderListingPage={true}
                    onDiscard={() =>
                        handleEventRetrigger(
                            notificationDetails,
                            retriggerEventNotification === 'fromSummary' && true
                        )
                    }
                    onClose={() => {
                        setRetriggerEventNotification(false);
                        setNotificationDetails({});
                    }}
                />
            )}
        </>
    );
};

export default OrderCard;
